import { useState } from "react";
import ImageGuidelinesContent from "./ImageGuidelinesContent";

function ChevronIcon({ open }) {
	return (
		<svg
			className={[
				"h-4 w-4 shrink-0 text-darkBlue/70 transition-transform duration-200",
				open ? "rotate-180" : "",
			].join(" ")}
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			aria-hidden
		>
			<path d="M6 9l6 6 6-6" />
		</svg>
	);
}

/** ستون راست داشبورد — راهنمای اندازه تصاویر */
export default function DashboardImageGuidelinesAside({ className = "" }) {
	const [open, setOpen] = useState(false);

	return (
		<aside
			className={[
				"hidden shrink-0 xl:block xl:w-[300px]",
				className,
			].join(" ")}
			aria-label="راهنمای عکس‌ها"
		>
			<div className="sticky top-24 max-h-[calc(100vh-7rem)] overflow-y-auto rounded-[14px] border border-cta/25 bg-gradient-to-b from-lightCta/90 to-white shadow-sm">
				<button
					type="button"
					onClick={() => setOpen((v) => !v)}
					className="flex w-full items-center justify-between gap-2 border-b border-darkBlue/10 px-4 py-3 text-right"
					aria-expanded={open}
				>
					<span className="font-Vazir-800 text-[15px] text-darkBlue">
						راهنمای عکس‌ها
					</span>
					<ChevronIcon open={open} />
				</button>
				{open && (
					<div className="p-4">
						<ImageGuidelinesContent compact />
					</div>
				)}
			</div>
		</aside>
	);
}
